<template>
  <form class="p-2" @submit.prevent="handleAddContainer">
    <ModalContainer :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize">
          {{ isEdit ? $t("edit_container") : $t("add_container") }}
        </h4>
      </template>
      <template slot="body" class="row">
        <div class="col-12">
          <div class="row">
            <!-- Product (Optional) -->
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label for="product">{{ $t("product") }} </label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="product"
                    id="product"
                    placeholder="Enter Product"
                    required
                  />
                </div>
              </div>
            </div>

            <!-- Pallet -->
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label for="pallet">{{ $t("no-of-pallet") }}</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="pallet"
                    required
                    id="pallet"
                    placeholder="Enter Pallet"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Container Number -->
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label for="containerNumber">{{
                  $t("container_number")
                }}</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="containerNumber"
                    required
                    id="containerNumber"
                    placeholder="Enter Container Number"
                  />
                </div>
              </div>
            </div>

            <!-- Devices -->
            <div class="col-12 col-sm-6">
              <div class="form-group w-100">
                <label for="assignedDevices">{{ $t("assign_device") }}</label>
                <Dropdown
                  :items="dropdownDevices"
                  @update:selectedItems="handleSelectedItems"
                  :itemsSelected="assignedDevices"
                  :selectPlaceholder="$t('select-device')"
                  :selectedDevicesPlaceholder="$t('devices-selected')"
                  :selectedDevicePlaceholder="$t('device-selected')"
                />
                <p v-if="showError" class="text-error font-12 mb-0">
                  {{ $t("select_one_device") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize">
            {{ isEdit ? $t("save") : $t("add") }}
          </button>
        </div>
      </template>
    </ModalContainer>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Dropdown from "../Dispatch/AddDispatch/Dropdown.vue";
import ModalContainer from "../../components/ModalContainer.vue";

export default {
  components: { Dropdown, ModalContainer },
  name: "AddContainerModal",
  props: {
    show: Boolean,
    onCancel: Function,
    containerData: Object,
    devicesByStatus: Array, 
  },
  data() {
    return {
      product: "",
      pallet: "",
      containerNumber: "",
      assignedDevices: [],
      showError: false,
      isEdit: false,
    };
  },
  methods: {
    // ...mapActions(["getDevicesByStatus"]),

    handleAddContainer() {
      const payload = {
        product: this.product,
        pallet: this.pallet,
        containerNumber: this.containerNumber,
        assignedDevices: this.assignedDevices,
      };
      if (!this.assignedDevices.length) {
        this.showError = true;
        return false;
      }
      if (this.isEdit) {
        this.$emit("edit-container", payload);
        return;
      }
      this.$emit("add-container", payload);
    },
    handleSelectedItems(selectedItems) {
      this.assignedDevices = selectedItems;
      this.showError = false;
    },
  },
  computed: {
    ...mapGetters(["devices"]),
    dropdownDevices() {
      const ongoingDeviceIds = this.devicesByStatus.map(device => device.id);

      return this.devices
        .filter(device => !ongoingDeviceIds.includes(device.id))
        .map(device => ({
          id: device.id,
          name: device.settings.name,
        }));
    },
  },
  watch: {
    containerData: {
      handler(val) {
        if (val && val.product) {
          this.isEdit = true;
          this.product = val.product;
          this.pallet = val.pallet;
          this.containerNumber = val.containerNumber;
          this.assignedDevices = val.assignedDevices;
        } else {
          // Reset fields if containerData is empty
          this.isEdit = false;
          this.product = "";
          this.pallet = "";
          this.containerNumber = "";
          this.assignedDevices = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped></style>
